import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">更新动态</h2>
          <p className="text-sm text-foreground-500 mt-2">热门连载实时更新，精彩不容错过</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updatesData.map((item, idx) => (
            <div key={item.id} className="flex items-start gap-4 group cursor-pointer">
              <div className="flex-shrink-0 flex flex-col items-center pt-0.5">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: 'oklch(var(--primary-500))' }}></div>
                {idx < updatesData.length - 1 && (
                  <div className="w-px h-full min-h-[40px] mt-1" style={{ backgroundColor: 'oklch(var(--background-300))' }}></div>
                )}
              </div>

              <div className="flex-1 pb-6 min-w-0 group-hover:opacity-80 transition-opacity duration-200">
                <div className="flex items-center flex-wrap gap-2 mb-1">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className="text-xs px-2 py-0.5 rounded" style={{ backgroundColor: 'oklch(var(--primary-100) / 0.6)', color: 'oklch(var(--primary-600))' }}>
                    {item.comic}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800">{item.chapter}</h3>
                <p className="text-xs text-foreground-400 mt-1">{item.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}